<template>
    <div>
        <div
            class="c-switch-list c-switch-list--time"
            :class="{
                'is-disabled': isTimesDisabled,
                'is-initial': isInitialTimesFetch,
            }"
        >
            <template v-if="isInitialTimesFetch">
                <div class="c-switch-list__item" v-for="i in 5" />
            </template>

            <template v-else>
                <button
                    type="button"
                    class="c-switch-list__item"
                    v-for="time in times"
                    :key="time.id"
                    :class="{
                        'is-selected': time.id == selectedTimeId
                    }"
                    @click="changeTime(time.id)"
                >
                    <!-- <strong class="sc-strong">
                        {{ time.name }}
                    </strong> -->

                    <div class="sc-text center-block">
                        {{ time.time }}
                    </div>
                </button>
            </template>
        </div>

        <div v-if="selectedPriorityTime" class="c-switch-priority c-msg c-msg--info">
            {{ $t('Switch.Times.priorityInfo') }}
            <strong>{{ selectedPriorityTime }}</strong>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    methods: {
        changeTime(timeId) {
            this.$store.commit('SET_SELECTED_TIME_ID', timeId);
        },
    },
    computed: {
        ...mapState([
            'selectedTimeId',
            'isInitialTimesFetch',
            'times',
            'isTimesDisabled',
        ]),
        selectedPriorityTime() {
            if (this.isInitialTimesFetch) {
                return null;
            }

            const selectedTime = this.times.find((time) => time.id == this.selectedTimeId);

            return (selectedTime && selectedTime.priority) || null;
        },
    }
}
</script>
